import React from "react";

const SwitchCheckbox = ({ checked = false, handleChange, label, id }) => {
  return (
    <div className="form-check form-switch form-switch">
      <input
        type="checkbox"
        className="form-check-input"
        id={id}
        defaultChecked={checked}
        onChange={handleChange}
      />
      {label ? (
        <label className="form-check-label" htmlFor={id}>
          {label}
        </label>
      ) : null}
    </div>
  );
};

export default SwitchCheckbox;
